import { DEFAULT_ASPECT_RATIO as m } from "./constants.mjs";
const c = {
  md: 768,
  lg: 1024,
  xl: 1800
};
function R(t, r) {
  let o = 0, n = 0;
  for (const a of r) {
    if (t < n + a.items.length)
      break;
    n += a.items.length, o++;
  }
  return {
    rowIndex: o,
    isLastItemInRow: t === n + r[o].items.length - 1
  };
}
function d(t) {
  return t.aspectRatio || m;
}
function A(t, r, o, n, a) {
  const { rowIndex: l, isLastItemInRow: e } = R(r, o), f = d(t), u = l === n;
  return { item: t, index: r, rowIndex: l, isLastRow: u, shouldStretch: !u || a, isLastItemInRow: e, aspectRatio: f };
}
function i(t) {
  const { aspectRatio: r, shouldStretch: o } = t;
  return {
    flexGrow: o ? r : 0,
    aspectRatio: r.toString()
  };
}
function w(t, r) {
  return `${t}px ${r}px`;
}
function F(t, r) {
  return r >= c.xl && t.xl ? t.xl : r >= c.lg && t.lg ? t.lg : r >= c.md && t.md ? t.md : t.sm ? t.sm : [
    t.xl,
    t.lg,
    t.md,
    t.sm
  ].find((n) => n !== void 0) ?? 245;
}
const x = (t, r = 2) => parseFloat(t.toFixed(r));
function L(t, r, o, n) {
  if (!r) return 0;
  const a = Math.max(0, t - 1) * o, l = n - a;
  return x(l / r, 2);
}
export {
  R as findRowForItem,
  F as getCurrentHeight,
  w as getGapStyle,
  A as getItemRenderData,
  i as getItemStyleProps,
  d as getSafeAspectRatio,
  L as getTargetAspectSumForRow,
  x as toFixed
};
